<template>
  <main class="public-rates">
    <header class="hero">
      <div class="hero-content">
        <img src="/img/osfatun-cuotas-logo.png" alt="OSFATUN - Nuestro plan es cuidarte" />
        <h1>CUOTAS Y MÍNIMOS</h1>
        <h3>MONTOS CÁPITAS MÍNIMAS, MONOTRIBUTISTAS Y ADHERENTES</h3>
      </div>
    </header>

    <section class="rates-card">
      <nav class="tabs" aria-label="Tipos de cuota">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          :class="{ active: activeTab === tab.id }"
          @click="selectTab(tab.id)"
        >
          {{ tab.label }}
        </button>
      </nav>

      <div class="filters">
        <label>
          Zona
          <select v-model="zone" @change="loadRates">
            <option value="1">Zona A</option>
            <option value="2">Zona B</option>
            <option value="4">Zona C</option>
            <option value="3">Zona D</option>
            <option value="5">Zona E</option>
          </select>
        </label>
        <label v-if="activeTab === 'monotributo'">
          Monotributo
          <select v-model="affiliateType" @change="loadRates">
            <option value="3">Categoría A, B o C</option>
            <option value="4">Categoría D</option>
            <option value="5">Categoría E</option>
            <option value="6">Categoría F</option>
            <option value="7">Categoría G</option>
            <option value="8">Categoría H</option>
            <option value="9">Categoría I</option>
            <option value="10">Categoría J</option>
            <option value="11">Categoría K</option>
          </select>
        </label>
        <label>
          Mes
          <select v-model="month" @change="loadRates">
            <option v-for="(name, index) in months" :key="name" :value="index + 1">{{ name }}</option>
          </select>
        </label>
        <label>
          Año
          <select v-model="year" @change="loadRates">
            <option v-for="availableYear in years" :key="availableYear" :value="availableYear">{{ availableYear }}</option>
          </select>
        </label>
      </div>

      <h2>Vigencia: {{ months[month - 1] }} de {{ year }}</h2>
      <p v-if="loading" class="status">Cargando valores…</p>
      <p v-else-if="error" class="status error">{{ error }}</p>

      <div v-else class="table-wrapper">
        <table>
          <thead>
            <tr><th>Grupo familiar</th><th v-for="plan in plans" :key="plan.key">{{ plan.label }}</th></tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.label">
              <th>{{ row.label }}</th>
              <td v-for="plan in plans" :key="plan.key">{{ formatValue(row[plan.key]) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p v-if="locations.length" class="locations"><strong>Localidades:</strong> {{ locationNames }}</p>

      <aside v-if="clarifications" class="clarifications">
        <p>{{ clarifications }}</p>
      </aside>
    </section>
  </main>
</template>

<script>
import axios from "axios";

const rowDefinitions = [
  ["Individual Junior (18 a 30 años)", 4],
  ["Individual Joven (31 a 45 años)", 3],
  ["Individual Adulto (46 a 64 años)", 2],
  ["Cónyuge Junior (18 a 30 años)", 8],
  ["Cónyuge Joven (31 a 45 años)", 7],
  ["Cónyuge Adulto (46 a 64 años)", 6],
  ["Primer hijo dentro del GFP", 1],
  ["Segundo hijo dentro del GFP", 0],
  ["A partir del tercer hijo dentro del GFP", 5],
  ["Por cada mayor de 65 años", 9],
];

export default {
  name: "PublicCuotasMinimos",
  data() {
    const now = new Date();
    const currentYear = now.getFullYear();
    return {
      activeTab: "capita",
      affiliateType: 3,
      zone: 1,
      month: now.getMonth() + 1,
      year: currentYear,
      years: Array.from({ length: 5 }, (_, index) => currentYear - 2 + index),
      months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      tabs: [
        { id: "capita", label: "Cápita mínima opciones" },
        { id: "monotributo", label: "ACM Monotributistas" },
        { id: "adherentes", label: "Adherentes" },
      ],
      plans: [
        { key: "basico", label: "Básico" }, { key: "integral", label: "Integral" },
        { key: "premium", label: "Premium" }, { key: "uni1000", label: "UNI 1000" },
        { key: "uni2000", label: "UNI 2000" }, { key: "uni3000", label: "UNI 3000" },
        { key: "uni4000", label: "UNI 4000" },
      ],
      rows: [], locations: [], clarifications: "", loading: false, error: "",
    };
  },
  computed: {
    apiBase() { return process.env.VUE_APP_ROOT_API || "https://api.osfatun.com.ar"; },
    locationNames() { return this.locations.map(location => location.name).join(", "); },
    selectedAffiliateType() {
      if (this.activeTab === "adherentes") return 2;
      if (this.activeTab === "monotributo") return this.affiliateType;
      return 1;
    },
  },
  mounted() {
    this.loadRates();
    axios.get(`${this.apiBase}/api/general-settings/aclaraciones`)
      .then(({ data }) => { this.clarifications = data.value || ""; })
      .catch(() => {});
  },
  methods: {
    selectTab(tab) { this.activeTab = tab; this.loadRates(); },
    loadRates() {
      this.loading = true; this.error = "";
      Promise.all([
        axios.get(`${this.apiBase}/api/v1/getplan`, { params: { tipo_afiliado: this.selectedAffiliateType, zone_id: this.zone, year: this.year, month: this.month } }),
        axios.get(`${this.apiBase}/api/v1/locationsByZone/${this.zone}`),
      ]).then(([rates, locations]) => {
        this.rows = rowDefinitions.map(([label, index]) => ({ label, ...(rates.data[index] || {}) }));
        this.locations = locations.data || [];
      }).catch(() => { this.error = "No se pudieron cargar los valores. Intente nuevamente."; })
        .finally(() => { this.loading = false; });
    },
    formatValue(value) {
      if (value === null || typeof value === "undefined") return "—";
      const numeric = Number(value);
      return Number.isNaN(numeric) ? value : numeric.toLocaleString("es-AR", { style: "currency", currency: "ARS", maximumFractionDigits: 0 });
    },
  },
};
</script>

<style scoped>
.public-rates { min-height: 100vh; background: #f4f7f8; color: #264653; padding-bottom: 64px; }
.hero { min-height: 330px; padding: 42px max(6vw, 24px) 104px; color: white; background-color: #007f91; background-image: linear-gradient(rgba(0, 112, 132, .12), rgba(0, 112, 132, .12)), url('/img/osfatun-cuotas-header.png'); background-position: center; background-size: cover; }
.hero-content { width: min(1100px, 100%); margin: 0 auto; display: flex; flex-direction: column; align-items: center; text-align: center; }
.hero img { width: 100%; max-width: 220px; height: auto; margin-bottom: 75px; }
.hero h1 { margin: 0; color: #fff; font-size: 42px; font-weight: 800; line-height: 1.05; }
.hero h3 { margin: 14px 0 0; color: #fff; font-size: 18px; font-weight: 700; line-height: 1.35; }
.rates-card { width: min(1220px, 92vw); margin: -52px auto 0; padding: 32px; background: white; border-radius: 16px; box-shadow: 0 16px 45px rgba(18, 61, 72, .15); }
.tabs { display: flex; justify-content: center; gap: 8px; overflow-x: auto; border-bottom: 1px solid #dce6e8; }
.tabs button { padding: 14px 18px; border: 0; border-bottom: 3px solid transparent; background: transparent; color: #46636c; font-weight: 700; white-space: nowrap; cursor: pointer; }
.tabs button.active { color: #00758f; border-bottom-color: #f7ad32; }
.filters { display: flex; flex-wrap: wrap; gap: 18px; margin: 28px 0; }
.filters label { display: grid; gap: 7px; color: #00758f; font-weight: 700; }
.filters select { min-width: 150px; padding: 10px 34px 10px 10px; border: 1px solid #bed0d4; border-radius: 6px; background: white; color: #264653; }
.rates-card h2 { color: #00758f; font-size: 22px; }
.table-wrapper { overflow-x: auto; }
table { width: 100%; border-collapse: collapse; min-width: 940px; }
th, td { padding: 14px 12px; text-align: right; border-bottom: 1px solid #dfe8ea; }
th:first-child { text-align: left; min-width: 245px; }
thead th { color: #00758f; background: #edf6f7; }
.locations { margin-top: 24px; line-height: 1.6; }
.clarifications { margin-top: 24px; }
.clarifications p { margin: 0; color: #46636c; font-size: 12px; white-space: pre-line; line-height: 1.5; }
.status { padding: 30px; text-align: center; }.status.error { color: #b42318; }
@media (max-width: 700px) { .hero { min-height: 280px; padding: 32px 20px 82px; }.hero h3 { max-width: 520px; }.rates-card { padding: 20px; }.tabs { justify-content: flex-start; }.filters label, .filters select { width: 100%; }.filters label { flex: 1 1 100%; } }
</style>
